module.exports = __webpack_public_path__ + "media/images/icons/phone-c975b34b7993663c0d4be8b4094eb876.svg";